'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
export const INITIAL_STATE = ImmutableMap({
  byId: ImmutableMap({}),
  tracks: ImmutableMap({}),
  lessons: ImmutableMap({})
});

/**
 * Returns an immutable updater which flattens a translatable item
 * (achievement / track / lesson) by merging its metadata for the desired
 * language.
 */
const createLanguagePinner = preferredLanguage => translatable => {
  const currentLanguage = translatable.hasIn(['metadata', preferredLanguage]) ? preferredLanguage : translatable.get('metadata').keySeq().first();
  return translatable.merge(translatable.getIn(['metadata', currentLanguage])).merge({
    currentLanguage
  });
};
const stringifyLessonIds = track => track.updateIn(['lessons'], lessons => lessons.map(lesson => lesson.toString()));
const includeId = (item, id) => item.merge({
  id
});
export const updateAchievements = (state, response, preferredLanguage, pinLanguage = createLanguagePinner(preferredLanguage)) => state.mergeIn(['byId'], response.get('achievements', ImmutableMap()).map(achievement => achievement.merge({
  isRequesting: false,
  hasError: false,
  tracks: achievement.get('tracks', List()).toOrderedSet().map(track => track.toString())
}).merge(response.getIn(['users', achievement.get('userId', 0).toString()], ImmutableMap()))).map(pinLanguage)).mergeIn(['tracks'], response.get('tracks', ImmutableMap()).map(includeId).map(pinLanguage).map(stringifyLessonIds)).mergeIn(['lessons'], response.get('lessons', ImmutableMap()).map(includeId).map(pinLanguage));
export default function PublicAchievement(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.PUBLIC_ACHIEVEMENT_REQUESTING:
      return state.mergeIn(['byId', action.payload.publicId], {
        publicId: action.payload.publicId,
        isRequesting: true,
        hasError: false
      });
    case ActionTypes.PUBLIC_ACHIEVEMENT_RECEIVED:
      return updateAchievements(state, action.payload.response, action.payload.language);
    case ActionTypes.PUBLIC_ACHIEVEMENT_ERROR:
      return state.mergeIn(['byId', action.payload.publicId], {
        isRequesting: false,
        hasError: true
      });
    default:
      return state;
  }
}